import { ITrangThaiDangKyAn } from "../../../models/response/category/ITrangThaiDangKyAn";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eTrangThaiDangKyAnActionTypeIds {
    LOAD_START = "TRANG_THAI_DANG_KY_AN_LOAD_START",
    LOAD_SUCCESS = "TRANG_THAI_DANG_KY_AN_LOAD_SUCCESS",
    LOAD_ERROR = "TRANG_THAI_DANG_KY_AN_LOAD_ERROR",

    SAVE_START = "TRANG_THAI_DANG_KY_AN_SAVE_START",
    SAVE_SUCCESS = "TRANG_THAI_DANG_KY_AN_SAVE_SUCCESS",
    SAVE_ERROR = "TRANG_THAI_DANG_KY_AN_SAVE_ERROR",

    DELETE_START = "TRANG_THAI_DANG_KY_AN_DELETE_START",
    DELETE_SUCCESS = "TRANG_THAI_DANG_KY_AN_DELETE_SUCCESS",
    DELETE_ERROR = "TRANG_THAI_DANG_KY_AN_DELETE_ERROR",

    SHOW_EDIT_MODAL = "TRANG_THAI_DANG_KY_AN_SHOW_EDIT_MODAL",
    CLOSE_EDIT_MODAL = "TRANG_THAI_DANG_KY_AN_CLOSE_EDIT_MODAL",
}

export interface ITrangThaiDangKyAnLoadStart extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.LOAD_START, undefined> {}
export interface ITrangThaiDangKyAnLoadSuccess extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.LOAD_SUCCESS, ITrangThaiDangKyAn[]> {}
export interface ITrangThaiDangKyAnLoadError extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.LOAD_ERROR, string> {}

export interface ITrangThaiDangKyAnSaveStart extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.SAVE_START, ITrangThaiDangKyAn> {}
export interface ITrangThaiDangKyAnSaveSuccess extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.SAVE_SUCCESS, undefined> {}
export interface ITrangThaiDangKyAnSaveError extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.SAVE_ERROR, string> {}

export interface ITrangThaiDangKyAnDeleteStart extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.DELETE_START, number> {}
export interface ITrangThaiDangKyAnDeleteSuccess extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.DELETE_SUCCESS, undefined> {}
export interface ITrangThaiDangKyAnDeleteError extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.DELETE_ERROR, string> {}

export interface ITrangThaiDangKyAnShowEditModal extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.SHOW_EDIT_MODAL, ITrangThaiDangKyAn | undefined> {}
export interface ITrangThaiDangKyAnCloseEditModal extends IActionTypeBase<eTrangThaiDangKyAnActionTypeIds.CLOSE_EDIT_MODAL, undefined> {}

export type ITrangThaiDangKyAnActionTypes =
    | ITrangThaiDangKyAnLoadStart
    | ITrangThaiDangKyAnLoadSuccess
    | ITrangThaiDangKyAnLoadError
    | ITrangThaiDangKyAnSaveStart
    | ITrangThaiDangKyAnSaveSuccess
    | ITrangThaiDangKyAnSaveError
    | ITrangThaiDangKyAnDeleteStart
    | ITrangThaiDangKyAnDeleteSuccess
    | ITrangThaiDangKyAnDeleteError
    | ITrangThaiDangKyAnShowEditModal
    | ITrangThaiDangKyAnCloseEditModal;
